"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
var is_type_1 = require("./is-type");
var isArguments = function (value) {
    return is_type_1.default(value, 'Arguments');
};
exports.default = isArguments;
//# sourceMappingURL=is-arguments.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-arguments.js
// module id = 1110
// module chunks = 37